import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useFetch } from '../../hooks/useFetch';
import { settingsApi } from '../../api/contentApi';
import { pagesApi } from '../../api/pagesApi';
import { PageHero } from '../../components/ui/PageHero';
import { Button } from '../../components/ui/Button';
import { Seo } from '../../components/ui/Seo';

export function About() {
  const { data: settings } = useFetch(() => settingsApi.public(), []);
  const { data: page } = useFetch(() => pagesApi.getBySlug('a-propos'), []);

  const heroEyebrow = settings?.['apropos.hero_eyebrow'] || 'À propos';
  const heroTitre = settings?.['apropos.hero_titre'] || 'Une agence locale, un réseau national';
  const heroSousTitre =
    settings?.['apropos.hero_sous_titre'] ||
    "AXEO Services accompagne particuliers et professionnels dans leur quotidien, avec la rigueur d'un grand réseau et la proximité d'une équipe locale.";

  return (
    <>
      <Seo
        title="À propos — Votre agence AXEO Services à Cergy"
        description="AXEO Services Cergy, agence locale du réseau national, au service des particuliers et des professionnels de l'agglomération de Cergy-Pontoise depuis plusieurs années."
        path="/a-propos"
      />

      <PageHero
        eyebrow={heroEyebrow}
        title={heroTitre}
        subtitle={heroSousTitre}
        imageUrl={settings?.['apropos.hero_image_url']}
      />

      {page?.contenu && (
        <div className="prose-page">
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.contenu) }} />
        </div>
      )}

      <section className="section section--cta">
        <div className="container">
          <h2>Envie d'en savoir plus ?</h2>
          <div className="cta-actions">
            <Link to="/devis">
              <Button>Demander un devis</Button>
            </Link>
            <Link to="/contact">
              <Button variant="secondary">Nous contacter</Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
